function checkPopNewsletter() {
    const urlParams = new URLSearchParams(window.location.search);
    const param = urlParams.get('newsletter');
    if (param) {
        const signup = document.querySelector('#newsletter-signup');
        if (signup) {
            const newsletterName = signup.classList.contains('sdn') ? 'SDN' : 'QT';
            window.MicroModal.show('newsletter-signup', window.MicroModalConfig);
            const sourceName = urlParams.get('source') ? urlParams.get('source') : 'referral';

            // Set newsletter visit GA
            window.setNewsletterVisitGA(newsletterName, sourceName);
        }
    }
}

document.addEventListener('DOMContentLoaded', checkPopNewsletter);
